import { FormInstance } from 'antd';
import { NamePath } from 'antd/es/form/interface';

export const clearFormErrors = <T extends object>(form: FormInstance<T>) => {
  const fields = Object.keys(form.getFieldsValue()).map(field => ({
    name: [field] as NamePath,
    validating: false,
    errors: [],
  }));
  form.setFields(fields);
};

export const mapServerErrors = <T>(
  errors: Record<string, string[]>,
  map: Record<string, keyof T>,
): Record<keyof T, string[]> =>
  Object.entries(errors).reduce(
    (mappedErrors, [fieldName, fieldErrors]) => {
      const mappedFieldName = Object.entries(map).find(([name]) => fieldName === name)?.[1] || fieldName;

      return { ...mappedErrors, [mappedFieldName]: fieldErrors };
    },
    {} as Record<keyof T, string[]>,
  );

export const getServerSideErrors = (errors: Record<string | number, string[]>) => {
  return Object.entries(errors).map(([name, errorMessages]) => ({
    name: [name] as NamePath,
    errors: errorMessages,
  }));
};

export const handleServerFormErrors = <T>(form: FormInstance<T>, errors: Record<string, string[]>) => {
  const fields = getServerSideErrors(errors);
  form.setFields(fields);

  if (fields.length) {
    form.scrollToField(fields[0].name, { behavior: 'smooth', block: 'center', inline: 'center' });
  }
};
